import * as React from 'react';
import { Grid2 } from '@mui/material';


export type IActionCardWrap = {
    children?: React.ReactNode,
}


export function ActionCardWrap({ children }: IActionCardWrap) {

    return (
        <Grid2
            container
            spacing={3}
            sx={{ mb: 6 }}
        >
            {children}
        </Grid2>
    );
}